import { createRouter, createWebHistory } from 'vue-router'
function lazyLoad(view){
  return() => import(`@/views/${view}.vue`)
}
function lazyPage(view){
  return() => import(`@/views/page/${view}.vue`)
}
function lazyUser(view){
  return() => import(`@/views/User/${view}.vue`)
}
const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: lazyLoad('HomeView')
  },
  {
    path: '/trailer',
    name: 'TrailerView',
    component: lazyPage('TrailerView')
  },
  {
    path: '/content/:content_id',
    name: 'ContentView',
    component: lazyPage('ContentView'),
    props: true,
  },
  {
    path: '/login',
    name: 'LoginView',
    component: lazyUser('LoginView')
  },
  {
    path: '/unsubscribe',
    name: 'UnsubscribeView',
    component: lazyUser('UnsubscribeView')
  },
  {
    path: '/category/:id',
    name: 'categorysView',
    component: () => import(/* webpackChunkName: "ab3adHealthy" */ '../views/Category/categorysView.vue'),
    props:true
  },
  {
    path: '/search/:search',
    name: 'Search',
    component: () => import(/* webpackChunkName: "ab3adHealthy" */ '../views/page/SearchesView.vue'),
    props:true
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: lazyUser('Subscribe')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
